import {createSvgIcon} from '../create-svg-icon';

export const ViewWeekIcon = createSvgIcon(
  <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 18H4V6h4v12zm6 0h-4V6h4v12zm6 0h-4V6h4v12z" />
, 'ViewWeekOutlined');
